//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    event_id: string;
    template_id: string;
    requestBody: {
        matchingMarkets?: null | undefined | string;
        metadata?: null | undefined | Record<string, string>;
        name?: null | undefined | string;
        requiredParameters?: null | undefined | Record<string, string>;
        selectedLine?: null | undefined | number;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/events/{event_id}/markets/{template_id} -> post -> ${code}`);
    };
};

export const Response200IO = t.interface({
    message: t.string,
    response: t.union([t.null, t.undefined, t.interface({
        id: t.string,
        markets: t.record(t.string, t.interface({
            betLimits: t.interface({
                inPlay: t.interface({
                    liabilityLimit: t.number,
                    maxBet: t.number,
                    maxMultipleBet: t.number,
                    maxWin: t.number,
                }),
                prematch: t.interface({
                    liabilityLimit: t.number,
                    maxBet: t.number,
                    maxMultipleBet: t.number,
                    maxWin: t.number,
                }),
                show: t.interface({
                    liabilityLimit: t.number,
                    maxBet: t.number,
                    maxMultipleBet: t.number,
                    maxWin: t.number,
                }),
            }),
            display: t.boolean,
            dividends: t.union([t.null, t.undefined, t.interface({
                forecasts: t.array(t.interface({
                    dividend: t.number,
                    id: t.number,
                    second: t.string,
                    winner: t.string,
                })),
                tricasts: t.array(t.interface({
                    dividend: t.number,
                    id: t.number,
                    second: t.string,
                    third: t.string,
                    winner: t.string,
                })),
            })]),
            eachWay: t.interface({
                offered: t.boolean,
                termsWithBet: t.boolean,
            }),
            eventId: t.string,
            id: t.string,
            inPlaySettings: t.interface({
                betDelay: t.number,
                tradedInPlay: t.boolean,
            }),
            metadata: t.record(t.string, t.string),
            name: t.string,
            revision: t.number,
            rule4: t.union([t.null, t.undefined, t.array(t.interface({
                deduction: t.interface({
                    deduction: t.number,
                    endTime: t.string,
                }),
                selectionId: t.string,
            }))]),
            selections: t.record(t.string, t.interface({
                display: t.boolean,
                id: t.string,
                metadata: t.record(t.string, t.string),
                name: t.string,
                selectionType: t.interface({
                    first: t.union([t.null, t.undefined, t.interface({
                        source: t.interface({
                            away: t.union([t.null, t.undefined, t.number]),
                            home: t.union([t.null, t.undefined, t.number]),
                            lowerMinuteBound: t.union([t.null, t.undefined, t.number]),
                            p: t.union([t.null, t.undefined, t.string]),
                            quantity: t.union([t.null, t.undefined, t.number]),
                            t: t.union([t.null, t.undefined, t.interface({
                                type: t.string,
                            })]),
                            type: t.string,
                            upperMinuteBound: t.union([t.null, t.undefined, t.number]),
                            value: t.union([t.null, t.undefined, t.number]),
                        }),
                    })]),
                    participantId: t.union([t.null, t.undefined, t.string]),
                    second: t.union([t.null, t.undefined, t.interface({
                        source: t.interface({
                            away: t.union([t.null, t.undefined, t.number]),
                            home: t.union([t.null, t.undefined, t.number]),
                            lowerMinuteBound: t.union([t.null, t.undefined, t.number]),
                            p: t.union([t.null, t.undefined, t.string]),
                            quantity: t.union([t.null, t.undefined, t.number]),
                            t: t.union([t.null, t.undefined, t.interface({
                                type: t.string,
                            })]),
                            type: t.string,
                            upperMinuteBound: t.union([t.null, t.undefined, t.number]),
                            value: t.union([t.null, t.undefined, t.number]),
                        }),
                    })]),
                    source: t.union([t.null, t.undefined, t.interface({
                        away: t.union([t.null, t.undefined, t.number]),
                        home: t.union([t.null, t.undefined, t.number]),
                        lowerMinuteBound: t.union([t.null, t.undefined, t.number]),
                        p: t.union([t.null, t.undefined, t.string]),
                        quantity: t.union([t.null, t.undefined, t.number]),
                        t: t.union([t.null, t.undefined, t.interface({
                            type: t.string,
                        })]),
                        type: t.string,
                        upperMinuteBound: t.union([t.null, t.undefined, t.number]),
                        value: t.union([t.null, t.undefined, t.number]),
                    })]),
                    type: t.string,
                    underlyingSelection: t.union([t.null, t.undefined, t.string]),
                }),
                state: t.interface({
                    result: t.union([t.null, t.undefined, t.interface({
                        placeReductions: t.union([t.null, t.undefined, t.array(t.interface({
                            eachWayTerms: t.union([t.null, t.undefined, t.interface({
                                places: t.union([t.null, t.undefined, t.number]),
                                reductionFactor: t.union([t.null, t.undefined, t.string]),
                            })]),
                            placeReduction: t.union([t.null, t.undefined, t.string]),
                        }))]),
                        result: t.union([t.null, t.undefined, t.interface({
                            place: t.union([t.null, t.undefined, t.number]),
                            type: t.string,
                        })]),
                        winReduction: t.union([t.null, t.undefined, t.string]),
                    })]),
                    type: t.string,
                }),
                uuid: t.string,
            })),
            settings: t.interface({
                autoTakeDown: t.boolean,
                bestOddsGuaranteed: t.boolean,
                betReferralEnabled: t.boolean,
                blockSettlement: t.boolean,
                bpApplicable: t.boolean,
                cashOut: t.boolean,
                cashoutMarketSettings: t.union([t.null, t.undefined, t.interface({
                    baseCashout: t.union([t.null, t.undefined, t.number]),
                    cashoutOfferEasing: t.union([t.null, t.undefined, t.number]),
                    cashoutOverround: t.union([t.null, t.undefined, t.number]),
                })]),
                eachWayStakeReduction: t.number,
                feedSettings: t.interface({
                    eachWay: t.boolean,
                    prices: t.boolean,
                    results: t.boolean,
                    updates: t.boolean,
                }),
                forecastOffered: t.union([t.null, t.undefined, t.boolean]),
                rule4: t.boolean,
                singlesOnly: t.boolean,
                spApplicable: t.boolean,
                startingPrice: t.boolean,
                startingPriceOnly: t.boolean,
                tricastOffered: t.union([t.null, t.undefined, t.boolean]),
            }),
            suspendTime: t.union([t.null, t.undefined, t.string]),
            uuid: t.string,
        })),
        revision: t.number,
        type: t.string,
    })]),
    status: t.string,
});
export type Response200Type = {
    message: string;
    response?: null | undefined | {
        id: string;
        markets: Record<string, {
            betLimits: {
                inPlay: {
                    liabilityLimit: number;
                    maxBet: number;
                    maxMultipleBet: number;
                    maxWin: number;
                };
                prematch: {
                    liabilityLimit: number;
                    maxBet: number;
                    maxMultipleBet: number;
                    maxWin: number;
                };
                show: {
                    liabilityLimit: number;
                    maxBet: number;
                    maxMultipleBet: number;
                    maxWin: number;
                };
            };
            display: boolean;
            dividends?: null | undefined | {
                forecasts: Array<{
                    dividend: number;
                    id: number;
                    second: string;
                    winner: string;
                }>;
                tricasts: Array<{
                    dividend: number;
                    id: number;
                    second: string;
                    third: string;
                    winner: string;
                }>;
            };
            eachWay: {
                offered: boolean;
                termsWithBet: boolean;
            };
            eventId: string;
            id: string;
            inPlaySettings: {
                betDelay: number;
                tradedInPlay: boolean;
            };
            metadata: Record<string, string>;
            name: string;
            revision: number;
            rule4?: null | undefined | Array<{
                deduction: {
                    deduction: number;
                    endTime: string;
                };
                selectionId: string;
            }>;
            selections: Record<string, {
                display: boolean;
                id: string;
                metadata: Record<string, string>;
                name: string;
                selectionType: {
                    first?: null | undefined | {
                        source: {
                            away?: null | undefined | number;
                            home?: null | undefined | number;
                            lowerMinuteBound?: null | undefined | number;
                            p?: null | undefined | string;
                            quantity?: null | undefined | number;
                            t?: null | undefined | {
                                type: string;
                            };
                            type: string;
                            upperMinuteBound?: null | undefined | number;
                            value?: null | undefined | number;
                        };
                    };
                    participantId?: null | undefined | string;
                    second?: null | undefined | {
                        source: {
                            away?: null | undefined | number;
                            home?: null | undefined | number;
                            lowerMinuteBound?: null | undefined | number;
                            p?: null | undefined | string;
                            quantity?: null | undefined | number;
                            t?: null | undefined | {
                                type: string;
                            };
                            type: string;
                            upperMinuteBound?: null | undefined | number;
                            value?: null | undefined | number;
                        };
                    };
                    source?: null | undefined | {
                        away?: null | undefined | number;
                        home?: null | undefined | number;
                        lowerMinuteBound?: null | undefined | number;
                        p?: null | undefined | string;
                        quantity?: null | undefined | number;
                        t?: null | undefined | {
                            type: string;
                        };
                        type: string;
                        upperMinuteBound?: null | undefined | number;
                        value?: null | undefined | number;
                    };
                    type: string;
                    underlyingSelection?: null | undefined | string;
                };
                state: {
                    result?: null | undefined | {
                        placeReductions?: null | undefined | Array<{
                            eachWayTerms?: null | undefined | {
                                places?: null | undefined | number;
                                reductionFactor?: null | undefined | string;
                            };
                            placeReduction?: null | undefined | string;
                        }>;
                        result?: null | undefined | {
                            place?: null | undefined | number;
                            type: string;
                        };
                        winReduction?: null | undefined | string;
                    };
                    type: string;
                };
                uuid: string;
            }>;
            settings: {
                autoTakeDown: boolean;
                bestOddsGuaranteed: boolean;
                betReferralEnabled: boolean;
                blockSettlement: boolean;
                bpApplicable: boolean;
                cashOut: boolean;
                cashoutMarketSettings?: null | undefined | {
                    baseCashout?: null | undefined | number;
                    cashoutOfferEasing?: null | undefined | number;
                    cashoutOverround?: null | undefined | number;
                };
                eachWayStakeReduction: number;
                feedSettings: {
                    eachWay: boolean;
                    prices: boolean;
                    results: boolean;
                    updates: boolean;
                };
                forecastOffered?: null | undefined | boolean;
                rule4: boolean;
                singlesOnly: boolean;
                spApplicable: boolean;
                startingPrice: boolean;
                startingPriceOnly: boolean;
                tricastOffered?: null | undefined | boolean;
            };
            suspendTime?: null | undefined | string;
            uuid: string;
        }>;
        revision: number;
        type: string;
    };
    status: string;
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffCreateEventMarketRequest"
 */
export const openapi_proxy_staff_create_event_market = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/events/${params.event_id}/markets/${params.template_id}${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffCreateEventMarketParamsType = ParamsType;

export type OpenapiProxyStaffCreateEventMarketResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffCreateEventMarketResponse200Type = Response200Type;

export const openapiProxyStaffCreateEventMarketRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffCreateEventMarketResponseType> => {
    const response = await openapi_proxy_staff_create_event_market(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffCreateEventMarketRequest - unhandled response ${response.status}`);
};

